class LineItem extends HTMLElement {
  constructor() {
    super()
    this.initialiseLineItem()
  }

  initialiseLineItem() {

    const change = this.handleChange

    // watch for url changes
    let previousUrl = ''
    const observer = new MutationObserver(function (mutations) {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href
        change()
      }
    });

    const config = { subtree: true, childList: true }
    observer.observe(document, config)
  }

  handleChange(event) {
    const shipping = document.querySelector('input[name="properties[shipping from]"')
    const newdate = document.querySelector('.prd-Basket-Message--show')?.getAttribute('data-date')
    if (newdate != null || newdate != undefined) {
      shipping.value = newdate
    } else {
      shipping.value = ''
    }
  }
}

customElements.define('line-item', LineItem)